'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var ConditionalWrap = require('conditional-wrap');
var _get = require('lodash/get');
var router = require('../router.js');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var reactRouterDom = require('react-router-dom');
require('@babel/runtime/helpers/defineProperty');
require('query-string');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ConditionalWrap__default = /*#__PURE__*/_interopDefaultLegacy(ConditionalWrap);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);

var _excluded = ["children", "className", "exact", "icon", "isBeta", "matchRoutes", "route"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var NavLink = bumbag.styled(bumbag.Link)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  align-items: center;\n  border-left: 5px solid transparent;\n  color: #e7e5e1;\n  display: flex;\n  height: 40px;\n  font-weight: ", ";\n  text-transform: uppercase;\n  text-decoration: none;\n\n  ", ";\n\n  ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n    color: white;\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: none;\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), bumbag.fontWeight('normal'), function (props) {
  return (// @ts-expect-error TS(2339): Property 'isMinimized' does not exist on type 'Pic... Remove this comment to see the full error message
    props.isMinimized ? bumbag.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose__default["default"](["\n          justify-content: center;\n          padding: 0;\n        "]))) : bumbag.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose__default["default"](["\n          padding-left: ", "rem;\n          padding-right: ", "rem;\n        "])), bumbag.space(2, 'major')(props), bumbag.space(3, 'major')(props))
  );
}, function (props) {
  return (// @ts-expect-error TS(2551): Property 'isActive' does not exist on type 'Pick<L... Remove this comment to see the full error message
    props.isActive && bumbag.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose__default["default"](["\n      background-color: ", ";\n      border-color: ", ";\n      color: white;\n    "])), bumbag.palette('primary600')(props), bumbag.palette('primary400')(props))
  );
}, bumbag.palette('primary600'), bumbag.palette('primary400'), bumbag.palette('primary600'), bumbag.palette('primary'));
var NavItemText = bumbag.styled(bumbag.Text)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose__default["default"](["\n  opacity: ", ";\n  white-space: nowrap;\n"])), function (props) {
  return (// @ts-expect-error TS(2339): Property 'isMinimized' does not exist on type 'Pic... Remove this comment to see the full error message
    props.isMinimized ? '0' : '1'
  );
});
function SidebarNavItem(_ref) {
  var _page$sidebar;

  var children = _ref.children;
      _ref.className;
      var _ref$exact = _ref.exact,
      exact = _ref$exact === void 0 ? false : _ref$exact,
      icon = _ref.icon,
      _ref$isBeta = _ref.isBeta,
      isBeta = _ref$isBeta === void 0 ? false : _ref$isBeta,
      _ref$matchRoutes = _ref.matchRoutes,
      matchRoutes = _ref$matchRoutes === void 0 ? null : _ref$matchRoutes,
      route = _ref.route,
      restProps = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded);

  var page = bumbag.usePage();

  var _useRouter = router.useRouter(),
      location = _useRouter.location; // @ts-expect-error TS(7006): Parameter 'route' implicitly has an 'any' type.


  function doesMatch(route) {
    var pathname = location.hash.replace('#', '') || location.pathname;

    var currentPrimaryRoute = _get__default["default"](pathname.split('/'), '[1]');

    var primaryRoute = _get__default["default"](route.split('/'), '[1]');

    return (exact ? pathname === route : currentPrimaryRoute === primaryRoute) || (matchRoutes || []).some(function (matchRoute) {
      if (exact || matchRoute === '/') {
        return pathname === matchRoute;
      }

      return pathname.includes(matchRoute);
    });
  }

  var handleClickItem = React__default["default"].useCallback(function () {
    page.sidebar.drawer.hide();
  }, [page == null ? void 0 : (_page$sidebar = page.sidebar) == null ? void 0 : _page$sidebar.drawer]);
  return /*#__PURE__*/React__default["default"].createElement(bumbag.List.Item, _extends__default["default"]({
    position: "relative"
  }, restProps), /*#__PURE__*/React__default["default"].createElement(ConditionalWrap__default["default"], {
    condition: page.sidebar.isMinimized // @ts-expect-error TS(7006): Parameter 'c' implicitly has an 'any' type.
    ,
    wrap: function wrap(c) {
      return /*#__PURE__*/React__default["default"].createElement(bumbag.Tooltip, {
        content: children,
        placement: "right",
        whiteSpace: "nowrap"
      }, c);
    }
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(NavLink // @ts-expect-error TS(2322): Type '{ children: Element[]; use: any; to: string;... Remove this comment to see the full error message
  , {
    use: reactRouterDom.Link,
    to: route,
    isActive: doesMatch(route),
    isMinimized: page.sidebar.isMinimized,
    onClick: handleClickItem
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Flex, {
    justifyContent: "center",
    marginRight: "major-1",
    width: "30px"
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: icon
  })), !page.sidebar.isMinimized && /*#__PURE__*/React__default["default"].createElement(NavItemText, null, children), !page.sidebar.isMinimized && isBeta && /*#__PURE__*/React__default["default"].createElement(bumbag.Tag, {
    palette: "primary",
    position: "absolute",
    right: "16px"
  }, "BETA")))));
}
SidebarNavItem.defaultProps = {
  className: '',
  exact: false,
  isBeta: false,
  matchRoutes: null
};

exports.SidebarNavItem = SidebarNavItem;
exports["default"] = SidebarNavItem;
